import { Injectable } from '@angular/core';
import { Authentication } from '@sb/library/api';
import { Elevio as ElevioConfiguration, ElevioOpenKind, Environment, VariantManager } from '@sb/library/base';
import Elevio from 'elevio/esm/client';

@Injectable({
    providedIn: 'root',
})
export class ElevioService {
    protected _elevioInitialized: boolean = false;
    protected _elevioGroups: string[] = [];
    protected _traits: {} = {};

    protected _elevioArticleOrModuleIDToOpen!: number
    protected _elevioOpenStep: ElevioOpenKind = ElevioOpenKind.Panel;

    constructor(
        private _Environment: Environment,
        private _VariantManager: VariantManager
    ) {
        ElevioConfiguration.Articles = this._Environment.Help?.Elevio?.ArticleIDs;
    }

    private OpenElevioPanel(): void {
        if (this._elevioInitialized) {
            switch (this._elevioOpenStep) {
                case ElevioOpenKind.Panel:
                    Elevio.open();
                    break;
                case ElevioOpenKind.Article:
                    Elevio.openArticle(this._elevioArticleOrModuleIDToOpen.toString());
                    break;
                case ElevioOpenKind.Module:
                    Elevio.openModule(this._elevioArticleOrModuleIDToOpen.toString());
                    break;
            }
        } else {
            this.StartElevio();
        }
    }

    private StartElevio(): void {
        if (this._Environment.Help!.Elevio!.Active) {
            Elevio.load(this._Environment.Help!.Elevio!.ElevioID!).then(() => {
                Elevio.setSettings({
                    articleFeedbackEnabled: false,
                    hideLauncher: true,
                    autoInitialize: false
                });
                Elevio.setUser(({
                    first_name: Authentication.FirstName,
                    last_name: Authentication.LastName,
                    email: Authentication.EmailAddress,
                    user_hash: Authentication.ElevioUserHash,
                    groups: this._elevioGroups,
                    traits: this._traits
                }));
                Elevio.setLanguage(this._VariantManager.appLanguage);
                Elevio.hideModules(this._Environment.Help!.Elevio!.Hidden!.map(item => `${item}`));
                Elevio.disableModules(this._Environment.Help!.Elevio!.Disabled!.map(item => `${item}`));
                Elevio.enable();
                Elevio.initialize();
                this._elevioInitialized = true;
                if (this._elevioOpenStep == ElevioOpenKind.Module) {
                    // Elevio openModule needs the additional time before it can execute something
                    setTimeout(() => {
                        this.OpenElevioPanel();
                    }, 500);
                } else {
                    this.OpenElevioPanel();
                }
            });
        } else {
            console.log("Elev.io is not active.");
        }
    }

    //NOTE: These are not the ElevioGroups types or ElevioUserTraits types from library/base.
    SetElevioSetupData(elevioGroups: string[], elevioUserTraits: {}): void {
        this._elevioGroups = elevioGroups;
        this._traits = elevioUserTraits;
    }

    OpenElevio(): void {
        this._elevioOpenStep = ElevioOpenKind.Panel;
        this.OpenElevioPanel();
    }

    OpenElevioArticle(articleID: number): void {
        this._elevioOpenStep = ElevioOpenKind.Article;
        this._elevioArticleOrModuleIDToOpen = articleID;
        this.OpenElevioPanel();
    }

    OpenElevioModule(moduleID: number): void {
        this._elevioOpenStep = ElevioOpenKind.Module;
        this._elevioArticleOrModuleIDToOpen = moduleID;
        this.OpenElevioPanel();
    }

    IsElevioOpen(): boolean {
        const elevioElement = document.querySelector('#_elev_io_placebo > #_elev_io_placebo') as HTMLElement;
        if (elevioElement) {
            return elevioElement.tabIndex >= 0;
        }
        return false;
    }

    CloseElevio(): void {
        Elevio.close();
    }
}
